//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { updateFormAuxiliary, selectForms } from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { Button } from '@carbon/react'

//// Carbon Icons
import { Add } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AddContactFormComponent = () => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Addition Of Contact Form Component
    const handleAddContactFormComponent = async () => {
        dispatch(
            updateFormAuxiliary({
                digital_name: settingsData?.['form']?.['digital_name'],
                auxiliary: {
                    satellite_location: true,
                },
            })
        )
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <nav className="half-width-button-with-icon-and-paragraph-group">
                <div className="half-width-button-with-icon-and-paragraph-group-item">
                    <p>Add Satellite Address(es):</p>
                </div>

                <div className="half-width-button-with-icon-and-paragraph-group-item">
                    <Button
                        className="fldoh-btn"
                        type="button"
                        kind="tertiary"
                        size="md"
                        onClick={handleAddContactFormComponent}
                        disabled={
                            formsData?.[
                                settingsData?.['form']?.['digital_name']
                            ]?.auxiliary?.satellite_location
                                ? true
                                : false
                        }
                    >
                        Add
                        <Add />
                    </Button>
                </div>
            </nav>
        </>
    )
}

export default AddContactFormComponent
